import { ApolloLink, Observable } from "@apollo/client";
import Cookies from "js-cookie";
import { handleForceLogout } from "@/features/workspace/hooks/useLogout";

const authLink = new ApolloLink((operation, forward) => {
  const isAuthenticated =
    !!Cookies.get("_s") && !!Cookies.get("authorized_person");
  const isSharePath = window.location.pathname.includes("share/candidate");
  const isAuthCallbackPath = window.location.pathname.includes("/auth/success");

  if (!isAuthenticated && !isSharePath && !isAuthCallbackPath) {
    handleForceLogout();
    return new Observable((observer) => {
      observer.complete();
    });
  }

  return forward(operation);
});

export default authLink;
